import type { RouteRecordRaw } from "vue-router";

export const audioRecorderRoutes: RouteRecordRaw[] = [
  {
    path: "/audio_recorder/info",
    name: "audio_recorder-info",
    component: () => import("./info/AudioRecorderInfoPage.vue"),
    meta: {
      namespace: "audio_recorder",
      title: "tools_meta.audio_recorder_prefix",
    },
  },
  {
    path: "/audio_recorder/files",
    name: "audio_recorder-index",
    component: () => import("./files/AudioFileListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "audio_recorder",
      title: "tools_meta.audio_recorder_prefix",
    },
  },
  {
    path: "/audio_recorder/files/:id",
    name: "audio_recorder-show",
    component: () => import("./files/AudioFileLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "audio_recorder",
      title: "tools_meta.audio_recorder_prefix",
    },
    children: [
      {
        path: "settings",
        name: "audio_recorder-settings",
        component: () => import("./files/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "audio_recorder",
          title: "tools_meta.audio_recorder_prefix",
        },
      },
      {
        path: "share",
        name: "audio_recorder-share",
        component: () => import("./files/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "audio_recorder",
          title: "tools_meta.audio_recorder_prefix",
        },
      },
    ],
  },
  {
    path: "/audio_recorder/public_files/:id",
    name: "audio_recorder-public-show",
    component: () => import("./public_files/[id]/PublicAudioFilePage.vue"),
    meta: {
      namespace: "audio_recorder",
      title: "tools_meta.audio_recorder_prefix",
    },
  },
];
